import { useState } from 'react'

import Layout from '../../components/layout/layout'
import CustomSplitter from '../../components/splitter/splitter'
import { menuItem } from '../../utils/helper'

import LeftContent from './left-content/left-content'
import RightContent from './right-content/right-content'

import "./index.css"

const Prompts = () => {
    const  [ selectedGridRow , setSelectedGridRow] = useState( {} )
  return (
    <Layout menuItem={menuItem} location={"/prompts"} >
      <CustomSplitter>
          <LeftContent selectedGridRow={selectedGridRow} setSelectedGridRow={setSelectedGridRow} />
          <RightContent selectedGridRow={selectedGridRow} setSelectedGridRow={setSelectedGridRow}/>
      </CustomSplitter>
    </Layout>
  )
}

export default Prompts